import posthog from 'posthog-js'
import mapRelationship from '@/utils/mapRelationship'
import { onAnalyticsConsent } from '@/utils/cookieConsent'

let isInitialized = false

function syncSessionRecording(analyticsAccepted) {
  if (analyticsAccepted) {
    posthog.startSessionRecording()
  } else {
    posthog.stopSessionRecording()
  }
}

function initializePosthog() {
  if (!isInitialized) {
    posthog.init(process.env.VUE_APP_POSTHOG_PROJECT_API_KEY, {
      api_host: process.env.VUE_APP_POSTHOG_API_HOST,
      autocapture: false,
      capture_pageview: false,
      defaults: '2025-05-24',
      person_profiles: 'identified_only',
      disable_session_recording: true,
      session_recording: { maskAllInputs: true }
    })

    if (process.env.VUE_APP_POSTHOG_DEBUG === 'on') {
      posthog.debug(true)
    }

    onAnalyticsConsent(syncSessionRecording)

    isInitialized = true
  }
}

initializePosthog()

function getCommonTrackingProperties(context) {
  const store = context.$store || context

  const merchant = store.getters.merchant
  const merchantID = store.getters.merchantID
  const isLoggedIn = store.getters.isLoggedIn

  const currentBottle = store.getters.currentBottle
  const storeId = currentBottle?.relationships?.store?.data?.id
  const storeObj = currentBottle?.relationships?.store?.data
    ? mapRelationship(store.state, currentBottle.relationships.store.data)
    : null
  const currentTokenCustomer = store.state.currentTokenCustomer
  return {
    merchant_id: merchantID,
    merchant_handle: merchant?.attributes?.handle,
    store_id: storeId,
    store_name: storeObj?.attributes?.store_name,
    customer_status: isLoggedIn ? 'logged_in' : 'not_logged_in',
    bottle_id: currentBottle?.attributes?.id,
    new_or_returning: currentTokenCustomer?.new ? 'new' : 'returning'
  }
}

export { posthog, getCommonTrackingProperties }
